import { atom } from "@mongez/react-atom";
import type { Category } from "core/catalog";

export const categoriesAtom: any = atom<Category[]>({
  key: "categories",
  default: [],
});
